var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowMini = function SvgArrowMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m20.78 16.202-8.21-8.987A.74.74 0 0 0 12 7a.74.74 0 0 0-.57.214l-8.21 8.987a.757.757 0 0 0 0 1.068.75.75 0 0 0 1.066 0L12 8.824l7.714 8.446a.75.75 0 0 0 1.065 0 .757.757 0 0 0 0-1.068"
  })), ";");
};
export default SvgArrowMini;